import React from 'react';
import { motion } from 'framer-motion';
const MODULES = [{
  num: '1',
  title: 'Insomnio en pacientes con ansiedad',
  desc: 'Detectá cuándo el insomnio está sostenido por preocupación, hiperactivación, rumiación y miedo a no dormir.'
}, {
  num: '2',
  title: 'Insomnio en pacientes con depresión',
  desc: 'Identificá insomnio con ánimo bajo, fatiga, despertar precoz, apatía y sueño no reparador.'
}, {
  num: '3',
  title: 'Conceptualización ansiedad-insomnio',
  desc: 'Entendé cómo la ansiedad alimenta el insomnio y el insomnio aumenta la ansiedad.'
}, {
  num: '4',
  title: 'Conceptualización depresión-insomnio',
  desc: 'Comprendé cómo se conecta el insomnio con ánimo bajo, fatiga y pérdida de rutina.'
}, {
  num: '5',
  title: 'Intervención cognitiva adaptada',
  desc: 'Aplicá preguntas, reformulaciones y registros cognitivos según el perfil del paciente.'
}, {
  num: '6',
  title: 'Intervención conductual adaptada',
  desc: 'Adaptá técnicas conductuales sin aumentar presión, frustración o abandono.'
}, {
  num: '7',
  title: 'Plan de sesiones ansiedad + insomnio',
  desc: 'Ordená el abordaje cuando predomina preocupación, hiperactivación y miedo a no dormir.'
}, {
  num: '8',
  title: 'Plan de sesiones depresión + insomnio',
  desc: 'Ordená el abordaje cuando predomina ánimo bajo, fatiga, apatía y despertar precoz.'
}, {
  num: '9',
  title: 'Seguimiento y señales de alerta',
  desc: 'Sostené avances, prevení recaídas y detectá señales que requieren mayor cuidado clínico.'
}];
export const ModulesSection: React.FC = () => {
  return <section className="py-12 sm:py-16 bg-offwhite px-4 sm:px-6 lg:px-8" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <div className="text-center mb-8 sm:mb-12" data-id="element-99">
          <h2 className="font-serif text-2xl sm:text-4xl font-bold text-navy mb-3" data-id="element-100">
            QUÉ INCLUYE ABORDAJE DEL INSOMNIO EN ANSIEDAD Y DEPRESIÓN
          </h2>
          <p className="text-base sm:text-xl text-accent font-semibold mb-1" data-id="element-101">
            Sistema Insomnio Clínico Adaptado™
          </p>
          <p className="text-gray-600 text-sm sm:text-lg" data-id="element-102">
            Una estructura profesional en 9 módulos:
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-5" data-id="element-103">
          {MODULES.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-white p-3 sm:p-5 rounded-lg shadow-sm border border-lavender flex flex-col gap-2" data-id="element-104">
              <div className="flex items-center gap-2" data-id="element-105">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-navy text-white rounded-full flex items-center justify-center font-serif text-base sm:text-lg font-bold shrink-0" data-id="element-106">
                  {mod.num}
                </div>
                <h3 className="font-serif text-xs sm:text-base font-bold text-navy leading-tight" data-id="element-107">
                  {mod.title}
                </h3>
              </div>
              <p className="text-gray-600 text-xs sm:text-sm leading-snug" data-id="element-108">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};